import { z } from 'zod';
import { SPOKEN_ADDRESS_MAX_LENGTH } from '../location/types';

/**
 * The longest line a preview will speak (ADR-344): the longest line the setup
 * screens let a practice write, which is the spoken address. A spoken name is
 * shorter (`SPOKEN_NAME_MAX_LENGTH`).
 */
export const VOICE_PREVIEW_MAX_LENGTH = SPOKEN_ADDRESS_MAX_LENGTH;

/**
 * Ask to HEAR a line in the agent's voice (ADR-344).
 *
 * `personaId` / `agentId` are catalog ids (`@vagusx/shared` voice catalog),
 * resolved the way the voice worker resolves a call's: absent or unknown means
 * the deployment default. The setup screens send neither, because a call that
 * names nobody is what a practice's inbound and test calls are.
 */
export const voicePreviewBodySchema = z.object({
  // Whitespace collapsed BEFORE the length check, as `spokenAddressSchema` does,
  // so a box the setup form accepts is never a line the preview refuses.
  text: z
    .string()
    .transform((text) => text.trim().replace(/\s+/g, ' '))
    .pipe(
      z
        .string()
        .min(1, 'Nothing to say')
        .max(VOICE_PREVIEW_MAX_LENGTH, `Keep it under ${VOICE_PREVIEW_MAX_LENGTH} characters`)
    ),
  personaId: z.string().min(1).optional(),
  agentId: z.string().min(1).optional(),
});
/** What a caller sends (`text` as typed); the API parses it to the collapsed line. */
export type VoicePreviewBody = z.input<typeof voicePreviewBodySchema>;
